import { Layout } from '../components';
import { TeamCard } from '../components/TeamCard/TeamCard';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { useNavigate } from 'react-router-dom';

const teamMembers = [
  {
    name: 'Sezgin Şener',
    position: 'Co-Founder & CEO',
    description:
      'Şirket vizyonunu belirler ve stratejik kararlar alır. İş geliştirme ve ortaklık yönetimi konusunda uzman.',
  },
  {
    name: 'Fatih Gökmen',
    position: 'Team Lead',
    description:
      'Takım yönetimi ve teknik liderlik konusunda uzman. Proje planlama ve geliştirme süreçlerini koordine eder.',
  },
  {
    name: 'Emrah Günay',
    position: 'Backend Developer',
    description:
      'Node.js, Python ve mikroservis mimarisi konusunda uzman. API geliştirme ve veritabanı optimizasyonu.',
  },
  {
    name: 'Eyüp Kayak',
    position: 'Backend Developer',
    description:
      'Java, Spring Boot ve cloud teknolojileri konusunda uzman. Sistem mimarisi ve performans optimizasyonu.',
  },
  {
    name: 'Şenol Günaydın',
    position: 'Backend Developer',
    description:
      '.NET Core ve Azure cloud platformu konusunda uzman. Enterprise uygulamalar ve sistem entegrasyonu.',
  },
  {
    name: 'Gamze Gülnur Düzgün',
    position: 'UI/UX Designer',
    description:
      'Kullanıcı deneyimi tasarımı ve arayüz geliştirme konusunda uzman. Figma ve design system uzmanı.',
  },
  {
    name: 'Utku Tunçal',
    position: 'Frontend Developer',
    description:
      'Next.js, React ve headless commerce konusunda uzman. Performans metrikleri ve Core Web Vitals optimizasyonu.',
  },
  {
    name: 'Rıdvan Polat',
    position: 'Cyber Security',
    description:
      'Siber güvenlik, penetrasyon testleri ve güvenlik denetimi konusunda uzman. ISO 27001 ve güvenlik standardları.',
  },
  {
    name: 'Hasan Alper Düzgün',
    position: 'Mobile Developer',
    description:
      'React Native ve Flutter teknolojileri konusunda uzman. Cross-platform mobil uygulama geliştirme.',
  },
  {
    name: 'Mikail Köse',
    position: 'Mobile Developer',
    description:
      'iOS ve Android native geliştirme konusunda uzman. Swift, Kotlin ve mobil uygulama performans optimizasyonu.',
  },
  {
    name: 'Emrah Doğru',
    position: 'Software Architect',
    description:
      'Yazılım mimarisi ve sistem tasarımı konusunda uzman. Scalable sistemler ve teknoloji stratejisi belirleme.',
  },
];

export function About() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollAnimation();
  const { ref: statsRef, isVisible: statsVisible } = useScrollAnimation();
  const { ref: storyRef, isVisible: storyVisible } = useScrollAnimation();
  const { ref: timelineRef, isVisible: timelineVisible } = useScrollAnimation();
  const { ref: valuesRef, isVisible: valuesVisible } = useScrollAnimation();
  const { ref: teamRef, isVisible: teamVisible } = useScrollAnimation();
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();
  const navigate = useNavigate();

  const mobileStyles = `
    @media (max-width: 768px) {
      .mobile-header-title {
        font-size: 36px !important;
        line-height: 40px !important;
        letter-spacing: -1.5px !important;
      }
      .mobile-header-description {
        font-size: 14px !important;
        line-height: 24px !important;
      }
      .mobile-stats-grid {
        grid-template-columns: 1fr !important;
        grid-template-rows: repeat(4, auto) !important;
        width: 100% !important;
        gap: 12px !important;
        height: auto !important;
        padding: 20px 0 !important;
      }
      .mobile-story-container {
        width: 100% !important;
        padding: 30px 0 20px 0 !important;
      }
      .mobile-story-content {
        width: 100% !important;
        max-width: 100% !important;
      }
      .mobile-timeline-container {
        width: 100% !important;
        padding: 30px 0 20px 0 !important;
      }
      .mobile-timeline-grid {
        padding: 20px 0 !important;
        gap: 20px !important;
        height: auto !important;
        position: relative !important;
      }
      .mobile-timeline-card {
        width: 100% !important;
        margin-top: 0 !important;
        align-self: stretch !important;
      }
      .mobile-timeline-line {
        display: none !important;
      }
      .mobile-timeline-dots {
        display: none !important;
      }
      .mobile-values-container {
        width: 100% !important;
        padding: 30px 0 !important;
      }
      .mobile-values-grid {
        grid-template-columns: 1fr !important;
        grid-template-rows: repeat(6, auto) !important;
        height: auto !important;
        padding: 20px 0 !important;
      }
      .mobile-values-card {
        grid-row: auto !important;
        grid-column: 1 !important;
      }
      .mobile-team-container {
        width: 100% !important;
        padding: 30px 0 40px 0 !important;
      }
      .mobile-team-grid {
        grid-template-columns: 1fr !important;
        grid-template-rows: repeat(6, auto) !important;
        height: auto !important;
        padding: 20px 0 !important;
      }
      .mobile-team-card {
        grid-row: auto !important;
        grid-column: 1 !important;
      }
      .mobile-cta-container {
        width: 100% !important;
        height: auto !important;
        padding: 32px 20px !important;
        margin-top: 32px !important;
      }
      .mobile-cta-title {
        font-size: 24px !important;
        letter-spacing: -0.5px !important;
      }
      .mobile-cta-description {
        font-size: 14px !important;
        line-height: 22px !important;
        max-width: 100% !important;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: mobileStyles }} />
      <Layout
        title="CommerceMinder"
        activePage="Hakkımızda"
        style={{
          background: 'linear-gradient(180deg, #020816 0%, #09101D 100%)',
        }}
      >
        {/* Header Section */}
        <section
          ref={heroRef as any}
          className={`pt-[124px] pb-[40px] px-4 transition-all duration-700 ease-out ${
            heroVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
        >
          <div className="max-w-[1200px] mx-auto text-center">
            {/* Badge */}
            <div
              style={{
                display: 'flex',
                padding: '6px 14px',
                alignItems: 'center',
                gap: '8px',
                borderRadius: '99px',
                border: '1px solid rgba(99, 102, 241, 0.20)',
                background: 'rgba(99, 102, 241, 0.08)',
                justifyContent: 'center',
                marginBottom: '24px',
                width: 'fit-content',
                margin: '0 auto 24px auto',
              }}
            >
              <span
                style={{
                  color: '#8BC1FA',
                  textAlign: 'center',
                  fontFamily: 'Inter',
                  fontSize: '11px',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  lineHeight: 'normal',
                }}
              >
                Biz Kimiz
              </span>
            </div>

            {/* Title */}
            <h1
              className="mobile-header-title"
              style={{
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '52px',
                fontStyle: 'normal',
                fontWeight: '900',
                lineHeight: '57.2px',
                letterSpacing: '-2.5px',
                marginBottom: '16px',
              }}
            >
              <span style={{ color: '#FFF' }}>E-Ticaretin </span>
              <span
                style={{
                  background:
                    'linear-gradient(104deg, #4A9CD8 0%, #76BCE8 50%, #A8D4F0 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Geleceğini
              </span>
              <br />
              <span style={{ color: '#FFF' }}>İnşa Ediyoruz</span>
            </h1>

            {/* Description */}
            <p
              className="mobile-header-description"
              style={{
                color: '#6B7280',
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '28.8px',
                maxWidth: '600px',
                margin: '0 auto',
              }}
            >
              CommerceMinder; ölçeklenebilir, yüksek performanslı ve güvenli
              e-ticaret altyapısıyla markaların dijital dönüşümüne güç katıyor.
            </p>
          </div>
        </section>

        {/* Stats Section */}
        <section
          ref={statsRef as any}
          className={`pb-[40px] px-4 transition-all duration-700 ease-out ${
            statsVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
        >
          <div className="max-w-[1200px] mx-auto">
            <div
              className="mobile-stats-grid"
              style={{
                display: 'grid',
                width: '1080px',
                height: '222px',
                padding: '50px 0',
                rowGap: '16px',
                columnGap: '16px',
                gridTemplateRows: '122px',
                gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                margin: '0 auto',
              }}
            >
              {/* Stat Card 1 */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '18px',
                  border: '1px solid rgba(255, 255, 255, 0.05)',
                  background: 'rgba(10, 12, 20, 0.90)',
                  padding: '24px',
                }}
              >
                <span
                  style={{
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '36px',
                    fontStyle: 'normal',
                    fontWeight: '900',
                    lineHeight: 'normal',
                    letterSpacing: '-1.5px',
                    background:
                      'linear-gradient(102deg, #E2E8F0 0%, #94A3B8 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    marginBottom: '8px',
                  }}
                >
                  35+
                </span>
                <span
                  style={{
                    color: '#4B5563',
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '11px',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: 'normal',
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  Entegrasyon
                </span>
              </div>

              {/* Stat Card 2 */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '18px',
                  border: '1px solid rgba(255, 255, 255, 0.05)',
                  background: 'rgba(10, 12, 20, 0.90)',
                  padding: '24px',
                }}
              >
                <span
                  style={{
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '36px',
                    fontStyle: 'normal',
                    fontWeight: '900',
                    lineHeight: 'normal',
                    letterSpacing: '-1.5px',
                    background:
                      'linear-gradient(102deg, #E2E8F0 0%, #94A3B8 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    marginBottom: '8px',
                  }}
                >
                  12K+
                </span>
                <span
                  style={{
                    color: '#4B5563',
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '11px',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: 'normal',
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  Günlük Sipariş
                </span>
              </div>

              {/* Stat Card 3 */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '18px',
                  border: '1px solid rgba(255, 255, 255, 0.05)',
                  background: 'rgba(10, 12, 20, 0.90)',
                  padding: '24px',
                }}
              >
                <span
                  style={{
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '36px',
                    fontStyle: 'normal',
                    fontWeight: '900',
                    lineHeight: 'normal',
                    letterSpacing: '-1.5px',
                    background:
                      'linear-gradient(102deg, #E2E8F0 0%, #94A3B8 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    marginBottom: '8px',
                  }}
                >
                  99.9%
                </span>
                <span
                  style={{
                    color: '#4B5563',
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '11px',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: 'normal',
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  Uptime SLA
                </span>
              </div>

              {/* Stat Card 4 */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '18px',
                  border: '1px solid rgba(255, 255, 255, 0.05)',
                  background: 'rgba(10, 12, 20, 0.90)',
                  padding: '24px',
                }}
              >
                <span
                  style={{
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '36px',
                    fontStyle: 'normal',
                    fontWeight: '900',
                    lineHeight: 'normal',
                    letterSpacing: '-1.5px',
                    background:
                      'linear-gradient(102deg, #E2E8F0 0%, #94A3B8 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    marginBottom: '8px',
                  }}
                >
                  4 Yıl
                </span>
                <span
                  style={{
                    color: '#4B5563',
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '11px',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: 'normal',
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  Sektör Deneyimi
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section
          ref={storyRef as any}
          className={`pb-[40px] px-4 transition-all duration-700 ease-out ${
            storyVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
        >
          <div className="max-w-[1200px] mx-auto">
            <div
              className="mobile-story-container"
              style={{
                display: 'flex',
                width: '1080px',
                padding: '40px 0 30px 0',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '15.1px',
                margin: '0 auto',
              }}
            >
              {/* Section Header */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '24px',
                }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '1px',
                    background: '#76BCE8',
                  }}
                />
                <span
                  style={{
                    color: '#76BCE8',
                    fontFamily: 'Inter',
                    fontSize: '10px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    letterSpacing: '1.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  Hikayemiz
                </span>
              </div>

              {/* Title */}
              <h2
                style={{
                  color: '#F1F5F9',
                  fontFamily: 'Inter',
                  fontSize: '32px',
                  fontStyle: 'normal',
                  fontWeight: '800',
                  lineHeight: 'normal',
                  letterSpacing: '-1.5px',
                  marginBottom: '32px',
                }}
              >
                Bir İhtiyaçtan Doğduk
              </h2>

              {/* Content */}
              <div
                className="mobile-story-content"
                style={{
                  display: 'flex',
                  width: '640px',
                  maxWidth: '640px',
                  paddingBottom: '0.695px',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '26.37px',
                }}
              >
                <p
                  style={{
                    color: '#6B7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    lineHeight: '26.6px',
                  }}
                >
                  2022 yılında, Türkiye'deki e-ticaret platformlarının karmaşık
                  entegrasyon süreçleri ve ölçeklenme sorunlarına tanık olduk.
                  Mevcut çözümler ya çok pahalıydı ya da teknik borç
                  biriktiriyordu. CommerceMinder, bu boşluğu doldurmak için
                  kuruldu.
                </p>

                <p
                  style={{
                    color: '#6B7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    lineHeight: '26.6px',
                  }}
                >
                  Amacımız basitti: işletmelerin büyümesini engelleyen teknik
                  bariyerleri kaldırmak. Bugün, mikroservis mimarisi üzerine
                  inşa edilmiş altyapımızla onlarca markanın dijital ticaretini
                  kesintisiz yönetiyoruz.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Timeline Section */}
        <section
          ref={timelineRef as any}
          className={`pb-[40px] px-4 transition-all duration-700 ease-out ${
            timelineVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
          style={{ position: 'relative' }}
        >
          <div className="max-w-[1200px] mx-auto">
            <div
              className="mobile-timeline-container"
              style={{
                display: 'flex',
                width: '1080px',
                padding: '40px 0 30px 0',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '15.1px',
                margin: '0 auto',
              }}
            >
              {/* Section Header */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '24px',
                }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '1px',
                    background: '#76BCE8',
                  }}
                />
                <span
                  style={{
                    color: '#76BCE8',
                    fontFamily: 'Inter',
                    fontSize: '10px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    letterSpacing: '1.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  Yolculuk
                </span>
              </div>

              {/* Title */}
              <h2
                style={{
                  color: '#F1F5F9',
                  fontFamily: 'Inter',
                  fontSize: '32px',
                  fontStyle: 'normal',
                  fontWeight: '800',
                  lineHeight: 'normal',
                  letterSpacing: '-1.5px',
                  marginBottom: '32px',
                }}
              >
                Kilometre Taşları
              </h2>

              {/* Timeline Container */}
              <div
                className="mobile-timeline-grid"
                style={{
                  display: 'flex',
                  padding: '40px 0 80.01px 0',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: 'var(--item-spacing-40, 40px)',
                  alignSelf: 'stretch',
                  position: 'relative',
                }}
              >
                {/* Timeline Line */}
                <div
                  className="mobile-timeline-line"
                  style={{
                    width: '1px',
                    height: '1134.72px',
                    position: 'absolute',
                    right: '539px',
                    background:
                      'linear-gradient(180deg, rgba(118, 188, 232, 0.00) 0%, rgba(118, 188, 232, 0.30) 50%, rgba(118, 188, 232, 0.00) 100%)',
                  }}
                />

                {/* Timeline Dots */}
                {/* Dot 1 */}
                <div
                  className="mobile-timeline-dots"
                  style={{
                    width: '12px',
                    height: '12px',
                    position: 'absolute',
                    left: '534px',
                    top: '40px',
                    borderRadius: '6px',
                    border:
                      'var(--stroke-weight-3, 3px) solid var(--color-blue-6, #0A0C14)',
                    background: 'var(--color-azure-69, #76BCE8)',
                  }}
                />

                {/* Dot 2 */}
                <div
                  className="mobile-timeline-dots"
                  style={{
                    width: '12px',
                    height: '12px',
                    position: 'absolute',
                    left: '534px',
                    top: '260px',
                    borderRadius: '6px',
                    border:
                      'var(--stroke-weight-3, 3px) solid var(--color-blue-6, #0A0C14)',
                    background: 'var(--color-azure-69, #76BCE8)',
                  }}
                />

                {/* Dot 3 */}
                <div
                  className="mobile-timeline-dots"
                  style={{
                    width: '12px',
                    height: '12px',
                    position: 'absolute',
                    left: '534px',
                    top: '480px',
                    borderRadius: '6px',
                    border:
                      'var(--stroke-weight-3, 3px) solid var(--color-blue-6, #0A0C14)',
                    background: 'var(--color-azure-69, #76BCE8)',
                  }}
                />

                {/* Dot 4 */}
                <div
                  className="mobile-timeline-dots"
                  style={{
                    width: '12px',
                    height: '12px',
                    position: 'absolute',
                    left: '534px',
                    top: '700px',
                    borderRadius: '6px',
                    border:
                      'var(--stroke-weight-3, 3px) solid var(--color-blue-6, #0A0C14)',
                    background: 'var(--color-azure-69, #76BCE8)',
                  }}
                />

                {/* Dot 5 */}
                <div
                  className="mobile-timeline-dots"
                  style={{
                    width: '12px',
                    height: '12px',
                    position: 'absolute',
                    left: '534px',
                    top: '920px',
                    borderRadius: '6px',
                    border:
                      'var(--stroke-weight-3, 3px) solid var(--color-blue-6, #0A0C14)',
                    background: 'var(--color-azure-69, #76BCE8)',
                  }}
                />

                {/* Dot 6 */}
                <div
                  className="mobile-timeline-dots"
                  style={{
                    width: '12px',
                    height: '12px',
                    position: 'absolute',
                    left: '534px',
                    top: '1140px',
                    borderRadius: '6px',
                    border:
                      'var(--stroke-weight-3, 3px) solid var(--color-blue-6, #0A0C14)',
                    background: 'var(--color-azure-69, #76BCE8)',
                  }}
                />

                {/* Timeline Cards */}
                {/* Card 1 - Left (Q1) */}
                <div
                  className="mobile-timeline-card"
                  style={{
                    display: 'flex',
                    width: '486px',
                    padding: '24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-5_2, 5.2px)',
                    borderRadius: '16px',
                    border:
                      'var(--stroke-weight-1, 1px) solid var(--color-white-5, rgba(255, 255, 255, 0.05))',
                    background: 'var(--color-blue-690, rgba(10, 12, 20, 0.90))',
                    alignSelf: 'flex-start',
                  }}
                >
                  <div
                    style={{
                      color: 'var(--Seagull, var(--color-azure-69, #76BCE8))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-11, 11px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                      letterSpacing: 'var(--letter-spacing-0_5, 0.5px)',
                    }}
                  >
                    2022 — Q1
                  </div>
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-91, #E2E8F0))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Kuruluş & MVP
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    İlk ekip oluşturuldu. .NET Core tabanlı monolitik yapı ile
                    minimum uygulanabilir ürün geliştirildi. İlk müşteri
                    onboarding tamamlandı.
                  </div>
                </div>

                {/* Card 2 - Right (Q4) */}
                <div
                  className="mobile-timeline-card"
                  style={{
                    display: 'flex',
                    width: '486px',
                    padding: '24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-5_2, 5.2px)',
                    borderRadius: '16px',
                    border:
                      'var(--stroke-weight-1, 1px) solid var(--color-white-5, rgba(255, 255, 255, 0.05))',
                    background: 'var(--color-blue-690, rgba(10, 12, 20, 0.90))',
                    alignSelf: 'flex-end',
                    marginTop: '40px',
                  }}
                >
                  <div
                    style={{
                      color: 'var(--Seagull, var(--color-azure-69, #76BCE8))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-11, 11px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                      letterSpacing: 'var(--letter-spacing-0_5, 0.5px)',
                    }}
                  >
                    2022 — Q4
                  </div>
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-91, #E2E8F0))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Mikroservis Geçişi
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    Monolitik yapı parçalandı. Sipariş, ödeme, kargo ve bildirim
                    servisleri bağımsız hale getirildi. RabbitMQ ve Redis
                    entegrasyonu yapıldı.
                  </div>
                </div>

                {/* Card 3 - Left (Q2) */}
                <div
                  className="mobile-timeline-card"
                  style={{
                    display: 'flex',
                    width: '486px',
                    padding: '24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-5_2, 5.2px)',
                    borderRadius: '16px',
                    border:
                      'var(--stroke-weight-1, 1px) solid var(--color-white-5, rgba(255, 255, 255, 0.05))',
                    background: 'var(--color-blue-690, rgba(10, 12, 20, 0.90))',
                    alignSelf: 'flex-start',
                    marginTop: '40px',
                  }}
                >
                  <div
                    style={{
                      color: 'var(--Seagull, var(--color-azure-69, #76BCE8))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-11, 11px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                      letterSpacing: 'var(--letter-spacing-0_5, 0.5px)',
                    }}
                  >
                    2023 — Q2
                  </div>
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-91, #E2E8F0))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Çoklu ERP Desteği
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    Mikro ERP ve Entegra entegrasyonları tamamlandı. Çift yönlü
                    stok senkronizasyonu ile envanter tutarsızlıkları sıfıra
                    indirildi.
                  </div>
                </div>

                {/* Card 4 - Right (Q1) */}
                <div
                  className="mobile-timeline-card"
                  style={{
                    display: 'flex',
                    width: '486px',
                    padding: '24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-5_2, 5.2px)',
                    borderRadius: '16px',
                    border:
                      'var(--stroke-weight-1, 1px) solid var(--color-white-5, rgba(255, 255, 255, 0.05))',
                    background: 'var(--color-blue-690, rgba(10, 12, 20, 0.90))',
                    alignSelf: 'flex-end',
                    marginTop: '40px',
                  }}
                >
                  <div
                    style={{
                      color: 'var(--Seagull, var(--color-azure-69, #76BCE8))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-11, 11px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                      letterSpacing: 'var(--letter-spacing-0_5, 0.5px)',
                    }}
                  >
                    2024 — Q1
                  </div>
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-91, #E2E8F0))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Global Ölçekleme
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    AWS multi-region mimarisine geçiş. Cloudflare Enterprise ile
                    global CDN. Avrupa pazarı için GDPR uyumlu altyapı
                    hazırlandı.
                  </div>
                </div>

                {/* Card 5 - Left (Q3) */}
                <div
                  className="mobile-timeline-card"
                  style={{
                    display: 'flex',
                    width: '486px',
                    padding: '24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-5_2, 5.2px)',
                    borderRadius: '16px',
                    border:
                      'var(--stroke-weight-1, 1px) solid var(--color-white-5, rgba(255, 255, 255, 0.05))',
                    background: 'var(--color-blue-690, rgba(10, 12, 20, 0.90))',
                    alignSelf: 'flex-start',
                    marginTop: '40px',
                  }}
                >
                  <div
                    style={{
                      color: 'var(--Seagull, var(--color-azure-69, #76BCE8))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-11, 11px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                      letterSpacing: 'var(--letter-spacing-0_5, 0.5px)',
                    }}
                  >
                    2025 — Q3
                  </div>
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-91, #E2E8F0))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    AI-Powered Öneriler
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    Makine öğrenmesi tabanlı ürün önerileri, dinamik fiyatlama
                    ve müşteri davranış analizi modülleri yayına alındı.
                  </div>
                </div>

                {/* Card 6 - Right (Şimdi) */}
                <div
                  className="mobile-timeline-card"
                  style={{
                    display: 'flex',
                    width: '486px',
                    padding: '24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-5_2, 5.2px)',
                    borderRadius: '16px',
                    border:
                      'var(--stroke-weight-1, 1px) solid var(--color-white-5, rgba(255, 255, 255, 0.05))',
                    background: 'var(--color-blue-690, rgba(10, 12, 20, 0.90))',
                    alignSelf: 'flex-end',
                    marginTop: '40px',
                  }}
                >
                  <div
                    style={{
                      color: 'var(--Seagull, var(--color-azure-69, #76BCE8))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-11, 11px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                      letterSpacing: 'var(--letter-spacing-0_5, 0.5px)',
                    }}
                  >
                    2026 — Şimdi
                  </div>
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-91, #E2E8F0))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Headless Commerce v2
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    Next.js tabanlı storefront, GraphQL API katmanı ve
                    composable commerce vizyonuyla yeni nesil e-ticaret deneyimi
                    sunuyoruz.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section
          ref={valuesRef as any}
          className={`pb-[40px] px-4 transition-all duration-700 ease-out ${
            valuesVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
        >
          <div className="max-w-[1200px] mx-auto">
            <div
              className="mobile-values-container"
              style={{
                display: 'flex',
                width: '1080px',
                padding: '40px 0',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 'var(--item-spacing-s, 16px)',
                margin: '0 auto',
              }}
            >
              {/* Section Header */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '24px',
                }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '1px',
                    background: '#76BCE8',
                  }}
                />
                <span
                  style={{
                    color: '#76BCE8',
                    fontFamily: 'Inter',
                    fontSize: '10px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    letterSpacing: '1.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  Değerlerimiz
                </span>
              </div>

              {/* Title */}
              <h2
                style={{
                  color: '#F1F5F9',
                  fontFamily: 'Inter',
                  fontSize: '32px',
                  fontStyle: 'normal',
                  fontWeight: '800',
                  lineHeight: 'normal',
                  letterSpacing: '-1.5px',
                  marginBottom: '32px',
                }}
              >
                Bizi Yönlendiren İlkeler
              </h2>

              {/* Values Grid */}
              <div
                className="mobile-values-grid"
                style={{
                  display: 'grid',
                  height: '492.73px',
                  paddingTop: '24px',
                  rowGap: '16px',
                  columnGap: '16px',
                  alignSelf: 'stretch',
                  gridTemplateRows: '236.56px 216.17px',
                  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                }}
              >
                {/* Value Card 1 */}
                <div
                  className="mobile-values-card"
                  style={{
                    display: 'flex',
                    padding: '30px 24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-6_9, 6.9px)',
                    gridRow: '1 / span 1',
                    gridColumn: '1 / span 1',
                    justifySelf: 'stretch',
                    borderRadius: '18px',
                    border:
                      'var(--stroke-weight-1, 1px) solid rgba(255, 255, 255, 0.05)',
                    background: 'rgba(10, 12, 20, 0.90)',
                  }}
                >
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-96, #F1F5F9))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Performans Öncelikli
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    Her milisaniye önemlidir. Altyapımız &lt;200ms yanıt süresi
                    hedefiyle optimize edilmiştir. Lazy loading, caching ve edge
                    computing ile kullanıcı deneyimini maksimize ediyoruz.
                  </div>
                </div>

                {/* Value Card 2 */}
                <div
                  className="mobile-values-card"
                  style={{
                    display: 'flex',
                    padding: '30px 24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-6_9, 6.9px)',
                    gridRow: '1 / span 1',
                    gridColumn: '2 / span 1',
                    justifySelf: 'stretch',
                    borderRadius: '18px',
                    border:
                      'var(--stroke-weight-1, 1px) solid rgba(255, 255, 255, 0.05)',
                    background: 'rgba(10, 12, 20, 0.90)',
                  }}
                >
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-96, #F1F5F9))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Güvenlik Odaklı
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    PCI DSS uyumlu ödeme altyapısı, AES-256 şifreleme, rate
                    limiting ve gerçek zamanlı tehdit algılama ile verilerinizi
                    koruyoruz.
                  </div>
                </div>

                {/* Value Card 3 */}
                <div
                  className="mobile-values-card"
                  style={{
                    display: 'flex',
                    padding: '30px 24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-6_9, 6.9px)',
                    gridRow: '1 / span 1',
                    gridColumn: '3 / span 1',
                    justifySelf: 'stretch',
                    borderRadius: '18px',
                    border:
                      'var(--stroke-weight-1, 1px) solid rgba(255, 255, 255, 0.05)',
                    background: 'rgba(10, 12, 20, 0.90)',
                  }}
                >
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-96, #F1F5F9))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Modüler Mimari
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    Composable commerce yaklaşımıyla her bileşen bağımsız
                    çalışır. İhtiyacınıza göre servisler ekleyip çıkarabilir,
                    kendi ekosistemleminizi oluşturabilirsiniz.
                  </div>
                </div>

                {/* Value Card 4 */}
                <div
                  className="mobile-values-card"
                  style={{
                    display: 'flex',
                    padding: '30px 24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-6_9, 6.9px)',
                    gridRow: '2 / span 1',
                    gridColumn: '1 / span 1',
                    justifySelf: 'stretch',
                    borderRadius: '18px',
                    border:
                      'var(--stroke-weight-1, 1px) solid rgba(255, 255, 255, 0.05)',
                    background: 'rgba(10, 12, 20, 0.90)',
                  }}
                >
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-96, #F1F5F9))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Sürekli İyileştirme
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    CI/CD pipeline'ları, otomatik testler ve canary deployment
                    ile haftada ortalama 12 release yapıyoruz. Kesintisiz
                    geliştirme, kesintisiz hizmet.
                  </div>
                </div>

                {/* Value Card 5 */}
                <div
                  className="mobile-values-card"
                  style={{
                    display: 'flex',
                    padding: '30px 24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-6_9, 6.9px)',
                    gridRow: '2 / span 1',
                    gridColumn: '2 / span 1',
                    justifySelf: 'stretch',
                    borderRadius: '18px',
                    border:
                      'var(--stroke-weight-1, 1px) solid rgba(255, 255, 255, 0.05)',
                    background: 'rgba(10, 12, 20, 0.90)',
                  }}
                >
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-96, #F1F5F9))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    Şeffaf İletişim
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    Status page, uptime monitörleri ve proaktif bildirimlerle
                    her zaman ne olduğunu bilirsiniz. Sorunları biz size haber
                    vermeden önce çözeriz.
                  </div>
                </div>

                {/* Value Card 6 */}
                <div
                  className="mobile-values-card"
                  style={{
                    display: 'flex',
                    padding: '30px 24px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--item-spacing-6_9, 6.9px)',
                    gridRow: '2 / span 1',
                    gridColumn: '3 / span 1',
                    justifySelf: 'stretch',
                    borderRadius: '18px',
                    border:
                      'var(--stroke-weight-1, 1px) solid rgba(255, 255, 255, 0.05)',
                    background: 'rgba(10, 12, 20, 0.90)',
                  }}
                >
                  <div
                    style={{
                      color:
                        'var(--Athens-Gray, var(--color-grey-96, #F1F5F9))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-15, 15px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    DX (Developer Experience)
                  </div>
                  <div
                    style={{
                      color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-12, 12px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-400, 400)',
                      lineHeight: 'var(--line-height-20_4, 20.4px)',
                    }}
                  >
                    Kapsamlı API dökümantasyonu, SDK'lar, webhook desteği ve
                    sandbox ortamı ile geliştirici dostu bir ekosistem
                    sunuyoruz.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section
          ref={teamRef as any}
          className={`pb-[40px] px-4 transition-all duration-700 ease-out ${
            teamVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
        >
          <div className="max-w-[1200px] mx-auto">
            <div
              className="mobile-team-container"
              style={{
                display: 'flex',
                width: '1080px',
                padding: '40px 0 60px 0',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 'var(--item-spacing-s, 16px)',
                margin: '0 auto',
              }}
            >
              {/* Section Header */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '24px',
                }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '1px',
                    background: '#76BCE8',
                  }}
                />
                <span
                  style={{
                    color: '#76BCE8',
                    fontFamily: 'Inter',
                    fontSize: '10px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    letterSpacing: '1.5px',
                    textTransform: 'uppercase',
                  }}
                >
                  Ekibimiz
                </span>
              </div>

              {/* Title */}
              <h2
                style={{
                  color: '#F1F5F9',
                  fontFamily: 'Inter',
                  fontSize: '32px',
                  fontStyle: 'normal',
                  fontWeight: '800',
                  lineHeight: 'normal',
                  letterSpacing: '-1.5px',
                  marginBottom: '32px',
                }}
              >
                Arkasındaki İnsanlar
              </h2>

              {/* Team Grid */}
              <div
                className="mobile-team-grid"
                style={{
                  display: 'grid',
                  height: 'auto',
                  paddingTop: '24px',
                  rowGap: '16px',
                  columnGap: '16px',
                  alignSelf: 'stretch',
                  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                  gridAutoRows: '256.56px',
                }}
              >
                {teamMembers.map((member, index) => (
                  <TeamCard
                    key={index}
                    name={member.name}
                    position={member.position}
                    description={member.description}
                  />
                ))}
              </div>

              {/* CTA Section */}
              <div
                ref={ctaRef as any}
                className={`mobile-cta-container transition-all duration-700 ease-out ${
                  ctaVisible
                    ? 'opacity-100 transform translate-y-0'
                    : 'opacity-0 transform translate-y-8'
                }`}
                style={{
                  width: '1080px',
                  height: '309.59px',
                  borderRadius: '24px',
                  border:
                    'var(--stroke-weight-1, 1px) solid var(--color-azure-6910, rgba(118, 188, 232, 0.10))',
                  background:
                    'var(--color-azure-693, rgba(118, 188, 232, 0.03))',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '24px',
                  padding: '40px',
                  marginTop: '40px',
                }}
              >
                {/* Title */}
                <h2
                  className="mobile-cta-title"
                  style={{
                    color: 'var(--Athens-Gray, var(--color-grey-96, #F1F5F9))',
                    textAlign: 'center',
                    fontFamily: 'var(--font-family-Font-3, Inter)',
                    fontSize: 'var(--font-size-28, 28px)',
                    fontStyle: 'normal',
                    fontWeight: 'var(--font-weight-800, 800)',
                    lineHeight: 'normal',
                    letterSpacing: 'var(--letter-spacing--1, -1px)',
                  }}
                >
                  Birlikte Çalışalım
                </h2>

                {/* Description */}
                <p
                  className="mobile-cta-description"
                  style={{
                    color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
                    textAlign: 'center',
                    fontFamily: 'var(--font-family-Font-3, Inter)',
                    fontSize: 'var(--font-size-14, 14px)',
                    fontStyle: 'normal',
                    fontWeight: 'var(--font-weight-400, 400)',
                    lineHeight: 'var(--line-height-23_8, 23.8px)',
                    maxWidth: '600px',
                  }}
                >
                  E-ticaret altyapınızı yeni nesil teknolojilerle güçlendirmek
                  ister misiniz?
                  <br />
                  Ekibimizle tanışın, projenizi konuşalım.
                </p>

                {/* CTA Button */}
                <button
                  onClick={() => navigate('/contact')}
                  style={{
                    display: 'inline-flex',
                    height: '44px',
                    padding: '18px 44px',
                    alignItems: 'center',
                    gap: 'var(--item-spacing-9_99, 9.99px)',
                    borderRadius: '14px',
                    background: '#76BCE8',
                    boxShadow: '0 4px 24px 0 rgba(118, 188, 232, 0.25)',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  <span
                    style={{
                      color: 'var(--Cod-Gray, var(--color-grey-4, #0A0A0A))',
                      textAlign: 'center',
                      fontFamily: 'var(--font-family-Font-3, Inter)',
                      fontSize: 'var(--font-size-14, 14px)',
                      fontStyle: 'normal',
                      fontWeight: 'var(--font-weight-700, 700)',
                      lineHeight: 'normal',
                    }}
                  >
                    İletişime Geç
                  </span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 12L10 8L6 4"
                      stroke="#0A0A0A"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
}
